jQuery(function($){
    if ($('.eigenschappen').length == 0){
        return;
    }

    let intersectTrigger = document.querySelector('.eigenschappen');  

    function handleIntersect(entries, observer) {
        entries.forEach(entry => {       
            if (entry.isIntersecting) {
                let eigenschappenContents = $('.eigenschappen__content');
                let eigenschappenFotos = $('.eigenschappen__foto');

                $('.eigenschappen__fotos').addClass('active');

                function updateActiveImage() {
                    let scrollPosition = $(window).scrollTop();

                    eigenschappenContents.each(function(index) {
                        let contentTop = $(this).offset().top;
                        let contentHeight = $(this).outerHeight();
                        
                        if (scrollPosition >= contentTop - $(window).height() / 2 && scrollPosition < contentTop + contentHeight) {
                            eigenschappenFotos.removeClass('active');
                            eigenschappenFotos.eq(index).addClass('active');
                        }
                    });
                }

                $(window).on('scroll.eigenschappen', updateActiveImage);
                updateActiveImage(); // Run on load to set the initial active image
            } else {
               $('.eigenschappen__fotos').removeClass('active');
               $(window).off('scroll.eigenschappen');
            }
        });
    }

    const observer = new IntersectionObserver(handleIntersect, {
        root: null, 
        threshold: 0.2
    });

    observer.observe(intersectTrigger);
});


